export const BookOpenIcon = (props) => (
  <svg
    {...props}
    width={props?.width || '20'}
    height={props?.height || '22'}
    viewBox="0 0 23 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.667 5C11.667 3.93913 11.2456 2.92172 10.4954 2.17157C9.74527 1.42143 8.72786 1 7.66699 1H1.66699V16H8.66699C9.46264 16 10.2257 16.3161 10.7883 16.8787C11.3509 17.4413 11.667 18.2044 11.667 19M11.667 5V19M11.667 5C11.667 3.93913 12.0884 2.92172 12.8386 2.17157C13.5887 1.42143 14.6061 1 15.667 1H21.667V16H14.667C13.8713 16 13.1083 16.3161 12.5457 16.8787C11.9831 17.4413 11.667 18.2044 11.667 19"
      stroke={props?.color || '#667085'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
